export default __webpack_public_path__ + "static/media/king.ec33a41a.png";